<template>
  <layout-machine-introduction :unsaved-puri-count="unsavedPuriCount"
                               :latest-image-id="latestImageId"
                               :is-searchable="isSearchable"
                               :machine-id="machineId"
                               :section-title-list="sectionTitleList"
                               :has-top-border-anchor-link="false"
                               :has-title-anchor-link="false"
                               :has-border-anchor-link="false"
                               :has-movie-title="false"
                               youtube-url="https://youtu.be/6X-JAw0o6Sw"
  >
    <template v-slot:feature-summary>
      <img :src="buildImgUrl('link_5.png')" alt="VERUAの基本情報">
    </template>
    <template v-slot:content-1>
      <div class="cont-01">
        <img class="img-01" :src="buildImgUrl('img_contents01_01.png')"
             alt="Point.01 儚さ感じるマットテイスト Point.02 可愛さ極めた美少女パーツ 画角はタテとヨコ選べるよ！">
        <img class="img-02" :src="buildImgUrl('img_contents01_02.png')"
             alt="もっと大人っぽくも可愛くもなれる大人盛れメイク 可愛い盛れメイクパレットで理想の自分に♡">
      </div>
    </template>
    <template v-slot:content-2>
      <div class="cont-02">
        <img class="img-01" :src="buildImgUrl('img_contents02_01.gif')"
             alt="シンプルなのにお洒落で大人っぽいVERUAのシールデザイン豊富なカラー展開とデザインでお気に入りの1枚がきっと見つかる♡">
      </div>
    </template>
    <template v-slot:content-3>
      <div class="cont-03">
        <div class="cont-03-bk">
          <img class="img-01" :src="buildImgUrl('img_contents03_01.gif')"
               alt="シールデザインを選んだ後にさらに自分好みにカスタムもできるよ">
          <img class="img-02" :src="buildImgUrl('img_contents03_02.png')"
               alt="こだわりたい部分だけにこだわれるから自分だけの特別な1枚に仕上がる♡">
        </div>
      </div>
    </template>
    <template v-slot:content-4>
      <div class="cont-04">
        <div class="cont-04-bk">
          <img class="img-01" :src="buildImgUrl('img_contents04_01.png')"
               alt="メイクペン　好きなところにチークとハイライトがのせられるよ ペンで描けるから普段のメイク感覚でこだわれる♡">
          <img class="img-02" :src="buildImgUrl('img_contents04_02.png')"
               alt="ヘアーエクステ スポイトを使って自分の髪色に合ったエクステをつけられる♡">
        </div>
      </div>
    </template>
  </layout-machine-introduction>
</template>

<script>
import LayoutMachineIntroduction from "../../templates/LayoutMachineIntroduction.vue";
import * as urlUtil from "../../../util/UrlUtil";
import {mapActions} from "vuex";

export default {
  name: "MachinePurimania2",
  components: {LayoutMachineIntroduction},
  props: {
    /**
     * Headerコンポーネント用
     * 未保存プリ数
     */
    unsavedPuriCount: {
      type: String,
      required: true
    },
    /**
     * Headerコンポーネント用
     * 最新プリID
     */
    latestImageId: {
      type: String,
      required: true
    },
    /**
     * 当該機種が「遊べるお店を探す」によって検索可能であるかどうかを判定する.
     * toolboxから取得
     * 「遊べるお店を探す」表示判定
     */
    isSearchable: {
      type: Boolean,
      required: true
    },
  },
  computed: {
    machineId() {
      return 159;
    },
    sectionTitleList() {
      return [
        '01 大人っぽいのに可愛い 儚い美少女盛れ',
        '02 高級感あるデザイン ブランドシール',
        '03 さらにこだわれる ブランドシールカスタム',
        '04 新機能 メイクペン&ヘアーエクステ',
      ];
    }
  },
  mounted() {
    /**
     * TheHeader,TheFooterでstoreのaccountStatusを使用するため、予めstoreに保存しておく
     * FIXME:ここでの取得を忘れてもエラーが出ず気づかない可能性があるため、VOYAGERFRONT-5558で修正予定
     */
    this.getAccountStatus()
  },
  methods: {
    ...mapActions({
      getAccountStatus: 'AccountStoreV2/getAccountStatus'
    }),
    /**
     * 画像のURLを組み立てる
     * @param {string} imgName 画像名
     */
    buildImgUrl(imgName) {
      return urlUtil.imageUrlUtil.machineIntroductionImageUrl(String(this.machineId), imgName)
    },
    /**
     * cssのurl関数の呼び出し部分の含めた文字列を返す
     * styleタグ内でv-bindで使用することを想定している
     */
    buildStyleImgUrl(imageName) {
      const imgUrl = this.buildImgUrl(imageName)
      return `url(${imgUrl})`;
    },
  }
}
</script>

<style scoped lang="scss">
@use "sass:math";
@use "../../../../scss/v2/base/variables";

$deviceWidth: 750px;

:deep(*) {
  .c-machine-introduction {
    &-top {
      .btn-shop-list {
        position: absolute;
        top: math.percentage(math.div(340px, $deviceWidth));
        left: 0;
        width: 100%;

        &-link {
          width: math.percentage(math.div(530px, $deviceWidth));
        }
      }

      .list-anchor-link {
        padding: (variables.$grid-base * 2) 0 0;

        .img-link {
          width: math.percentage(math.div(594px, $deviceWidth));
        }

        .img-line {
          width: math.percentage(math.div(594px, $deviceWidth));
          display: block;
          margin: auto;
        }
        &-feature-summary {
          background-image: v-bind("buildStyleImgUrl('link_bk.png')");
          background-repeat: no-repeat;
          background-size: 100%;
          margin-top: -13px;
          }
      }
    }

    &-contents {
      .accordion-inner {
        .img-01, .img-02, .img-03, .img-04, .img-05, .img-06, .img-07, {
          display: block;
        }

        .cont-03 {
          &-bk {
            background: v-bind("buildStyleImgUrl('img_contents03_bk.png')");
            background-size: cover;
          }
        }

        .cont-04 {
          &-bk {
            background: v-bind("buildStyleImgUrl('img_contents04_bk.png')");
            background-size: cover;
          }
        }
      }
    }

    &-movie {
      padding: variables.$grid-consistent * 18 0 variables.$grid-consistent * 13;
      background-image: v-bind("buildStyleImgUrl('movie_back.png')");
      background-repeat: no-repeat;
      background-position: center;
      background-size: cover;

      &-thumb {
        width: math.percentage(math.div(650px, $deviceWidth));
        margin: auto;
      }
    }
  }
}

</style>
